import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { useTranslation } from 'react-i18next';

export interface DeviceNameOrSerialNumberProps {
  device?: DeviceDTO;
}

export function DeviceNameOrSerialNumber({ device }: DeviceNameOrSerialNumberProps) {
  const { t } = useTranslation();

  if (!device) {
    return t('deviceDetail.fallbackHeadlineNameEmpty');
  }

  return device.name || device.serialNumber;
}
